import ERC20_ABI from 'abis/erc20.json'
import BigNumber from 'bignumber.js'
import { STAKE_POOL_ADDRESS } from 'constants/addresses'
import { SWC } from 'constants/tokens'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import useRefresh from 'hooks/useRefresh'
import { useCallback, useEffect, useState } from 'react'
import { BIG_ZERO } from 'utils/bigNumber'
import multicall from 'utils/multicall'

import { WalletBalancesData } from '../types'

/**
 * Gets all wallet data of token contract
 */
const useWalletBalances = (chainId: number): WalletBalancesData => {
  const { account } = useActiveWeb3React()
  const poolAddress = STAKE_POOL_ADDRESS[chainId]
  const swcAddress = SWC[chainId].address
  const { slowRefresh } = useRefresh()

  const [state, setState] = useState({
    swcBalance: BIG_ZERO,
    swcPoolAllowance: BIG_ZERO,
  })

  const fetchWalletData = useCallback(async () => {
    const userCalls = [
      {
        address: swcAddress,
        name: 'balanceOf',
        params: [account],
      },
      {
        address: swcAddress,
        name: 'allowance',
        params: [account, poolAddress],
      },
    ]

    const [swcBalance, swcPoolAllowance] = await multicall(chainId, ERC20_ABI, userCalls)

    setState((prev) => ({
      ...prev,
      swcBalance: new BigNumber(swcBalance[0].toString()),
      swcPoolAllowance: new BigNumber(swcPoolAllowance[0].toString()),
    }))
  }, [account, chainId, poolAddress, swcAddress])

  useEffect(() => {
    if (account) {
      fetchWalletData()
    }
  }, [account, fetchWalletData, slowRefresh])

  return { ...state, fetchWalletData }
}

export default useWalletBalances
